// Environment

export const CHANGE_IS_MOBILE = 'CHANGE_IS_MOBILE';
export const CHANGE_WIDTH_AND_HEIGHT = 'CHANGE_WIDTH_AND_HEIGHT';
export const SET_POPUP = 'SET_POPUP';

// Objects

export const SET_SCROLL_TOP = 'SET_SCROLL_TOP';

export const LOAD_OBJECTS_START = 'LOAD_OBJECTS_START';
export const LOAD_OBJECTS_SUCCESS = 'LOAD_OBJECTS_SUCCESS';
export const LOAD_OBJECTS_ERROR = 'LOAD_OBJECTS_ERROR';

export const LOAD_PINS_START = 'LOAD_PINS_START';
export const LOAD_PINS_SUCCESS = 'LOAD_PINS_SUCCESS';
export const LOAD_PINS_ERROR = 'LOAD_PINS_ERROR';

export const LOAD_POINT_START = 'LOAD_POINT_START';
export const LOAD_POINT_SUCCESS = 'LOAD_POINT_SUCCESS';
export const LOAD_POINT_ERROR = 'LOAD_POINT_ERROR';

export const LOAD_POINT_LIST_START = 'LOAD_POINT_LIST_START';
export const LOAD_POINT_LIST_SUCCESS = 'LOAD_POINT_LIST_SUCCESS';
export const LOAD_POINT_LIST_ERROR = 'LOAD_POINT_LIST_ERROR';

// Search

export const FORCED_SEARCH_CHANGE = 'FORCED_SEARCH_CHANGE';
export const CHANGE_FILTERS = 'CHANGE_FILTERS';
export const CHANGE_FOCUS = 'CHANGE_FOCUS';
export const LOAD_AUTOCOMPLETE = 'LOAD_AUTOCOMPLETE';
export const LOAD_AUTOCOMPLETE_FETCHING = 'LOAD_AUTOCOMPLETE_FETCHING';
export const LOAD_AUTOCOMPLETE_SUCCESS = 'LOAD_AUTOCOMPLETE_SUCCESS';
export const LOAD_AUTOCOMPLETE_ERROR = 'LOAD_AUTOCOMPLETE_ERROR';
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE';
export const SET_SEARCH_MODAL_STATE = 'SET_SEARCH_MODAL_STATE';

// Building

export const LOAD_BUILDING_START = 'LOAD_BUILDING_START';
export const LOAD_BUILDING_SUCCESS = 'LOAD_BUILDING_SUCCESS';
export const LOAD_BUILDING_ERROR = 'LOAD_BUILDING_ERROR';
export const TOGGLE_CHESS = 'TOGGLE_CHESS';

export const CREATE_INACCURACY_REPORT = 'CREATE_INACCURACY_REPORT';
export const CREATE_INACCURACY_REPORT_SUCCESS = 'CREATE_INACCURACY_REPORT_SUCCESS';
export const CREATE_INACCURACY_REPORT_ERROR = 'CREATE_INACCURACY_REPORT_ERROR';

// Chess

export const LOAD_PAVILIONS_START = 'LOAD_PAVILIONS_START';
export const LOAD_PAVILIONS_SUCCESS = 'LOAD_PAVILIONS_SUCCESS';
export const LOAD_PAVILIONS_ERROR = 'LOAD_PAVILIONS_ERROR';
export const SET_CHESS_CELLS = 'SET_CHESS_CELLS';
export const SET_CHESS_FILTERS = 'SET_CHESS_FILTERS';
export const SET_CELL_SELECTED = 'SET_CELL_SELECTED';
export const SET_CHESS_TABLE = 'SET_CHESS_TABLE';
export const SET_CHESS_EXTENDED = 'SET_CHESS_EXTENDED';
export const SET_CHESS_DESCRIPTION_HIDE = 'SET_CHESS_DESCRIPTION_HIDE';
export const SET_LIST_SORT = 'SET_LIST_SORT';
export const SET_TABLE_SCROLL = 'SET_TABLE_SCROLL';
export const SET_PREV_LOCATION = 'SET_PREV_LOCATION';
export const UPDATE_CHESS_STATE = 'UPDATE_CHESS_STATE';
export const SET_ZOOM = 'SET_ZOOM';
export const LOAD_CHESS_START = 'LOAD_CHESS_START';
export const LOAD_CHESS_SUCCESS = 'LOAD_CHESS_SUCCESS';
export const LOAD_CHESS_ERROR = 'LOAD_CHESS_ERROR';

// Documents

export const LOAD_DOCUMENTS_START = 'LOAD_DOCUMENTS_START';
export const LOAD_DOCUMENTS_SUCCESS = 'LOAD_DOCUMENTS_SUCCESS';
export const LOAD_DOCUMENTS_ERROR = 'LOAD_DOCUMENTS_ERROR';

// News

export const LOAD_NEWS_START = 'LOAD_NEWS_START';
export const LOAD_NEWS_SUCCESS = 'LOAD_NEWS_SUCCESS';
export const LOAD_NEWS_ERROR = 'LOAD_NEWS_ERROR';

// LoginForms

export const INVITE_FORM_SENDING_START = 'INVITE_FORM_SENDING_START';
export const INVITE_FORM_SENDING_SUCCESS = 'INVITE_FORM_SENDING_SUCCESS';
export const INVITE_FORM_SENDING_ERROR = 'INVITE_FORM_SENDING_ERROR';

export const NUMBER_FORM_SENDING_START = 'NUMBER_FORM_SENDING_START';
export const NUMBER_FORM_SENDING_SUCCESS = 'NUMBER_FORM_SENDING_SUCCESS';
export const NUMBER_FORM_SENDING_ERROR = 'NUMBER_FORM_SENDING_ERROR';

export const SMS_FORM_SENDING_START = 'SMS_FORM_SENDING_START';
export const SMS_FORM_SENDING_SUCCESS = 'SMS_FORM_SENDING_SUCCESS';
export const SMS_FORM_SENDING_ERROR = 'SMS_FORM_SENDING_ERROR';

export const RESTORE_FORM_SENDING_START = 'RESTORE_FORM_SENDING_START';
export const RESTORE_FORM_SENDING_SUCCESS = 'RESTORE_FORM_SENDING_SUCCESS';
export const RESTORE_FORM_SENDING_ERROR = 'RESTORE_FORM_SENDING_ERROR';

export const RECONNECT_FORM_SENDING_START = 'RECONNECT_FORM_SENDING_START';
export const RECONNECT_FORM_SENDING_SUCCESS = 'RECONNECT_FORM_SENDING_SUCCESS';
export const RECONNECT_FORM_SENDING_ERROR = 'RECONNECT_FORM_SENDING_ERROR';

export const USER_LOGIN = 'USER_LOGIN';

export const USER_LOGOUT_START = 'USER_LOGOUT_START';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_ERROR = 'USER_LOGOUT_ERROR';

export const REQUEST_TOKEN_START = 'REQUEST_TOKEN_START';
export const REQUEST_TOKEN_SUCCESS = 'REQUEST_TOKEN_SUCCESS';
export const REQUEST_TOKEN_ERROR = 'REQUEST_TOKEN_ERROR';

// Profile

export const LOAD_PROFILE_START = 'LOAD_PROFILE_START';
export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';
export const LOAD_PROFILE_ERROR = 'LOAD_PROFILE_ERROR';

export const EDIT_PROFILE_START = 'EDIT_PROFILE_START';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_ERROR = 'EDIT_PROFILE_ERROR';

export const UPLOAD_PHOTO_START = 'UPLOAD_PHOTO_START';
export const UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS';
export const UPLOAD_PHOTO_ERROR = 'UPLOAD_PHOTO_ERROR';

export const UPLOAD_LOGO_REQUEST = 'UPLOAD_LOGO_REQUEST';
export const UPLOAD_LOGO_OK = 'UPLOAD_LOGO_OK';
export const UPLOAD_LOGO_ERROR = 'UPLOAD_LOGO_ERROR';

export const CHECK_USER_PHONE_REQUEST = 'CHECK_USER_PHONE_REQUEST';
export const CHECK_USER_PHONE_OK = 'CHECK_USER_PHONE_OK';
export const CHECK_USER_PHONE_ERROR = 'CHECK_USER_PHONE_ERROR';

// Collections

export const LOAD_COLLECTIONS_START = 'LOAD_COLLECTIONS_START';
export const LOAD_COLLECTIONS_SUCCESS = 'LOAD_COLLECTIONS_SUCCESS';
export const LOAD_COLLECTIONS_ERROR = 'LOAD_COLLECTIONS_ERROR';

export const LOAD_COLLECTION_START = 'LOAD_COLLECTION_START';
export const LOAD_COLLECTION_SUCCESS = 'LOAD_COLLECTION_SUCCESS';
export const LOAD_COLLECTION_ERROR = 'LOAD_COLLECTION_ERROR';

export const LOAD_COLLECTION_BUILDING_LOTS_START = 'LOAD_COLLECTION_BUILDING_LOTS_START';
export const LOAD_COLLECTION_BUILDING_LOTS_SUCCESS = 'LOAD_COLLECTION_BUILDING_LOTS_SUCCESS';
export const LOAD_COLLECTION_BUILDING_LOTS_ERROR = 'LOAD_COLLECTION_BUILDING_LOTS_ERROR';

export const LOAD_COLLECTION_BUILDING_START = 'LOAD_COLLECTION_BUILDING_START';
export const LOAD_COLLECTION_BUILDING_SUCCESS = 'LOAD_COLLECTION_BUILDING_SUCCESS';
export const LOAD_COLLECTION_BUILDING_ERROR = 'LOAD_COLLECTION_BUILDING_ERROR';

export const SHARE_BUILDING_REQUEST = 'SHARE_BUILDING_REQUEST';
export const SHARE_BUILDING_SUCCESS = 'SHARE_BUILDING_SUCCESS';
export const SHARE_BUILDING_ERROR = 'SHARE_BUILDING_ERROR';

export const CREATE_COLLECTION_START = 'CREATE_COLLECTION_START';
export const CREATE_COLLECTION_SUCCESS = 'CREATE_COLLECTION_SUCCESS';
export const CREATE_COLLECTION_ERROR = 'CREATE_COLLECTION_ERROR';

export const DELETE_COLLECTION_START = 'DELETE_COLLECTION_START';
export const DELETE_COLLECTION_SUCCESS = 'DELETE_COLLECTION_SUCCESS';
export const DELETE_COLLECTION_ERROR = 'DELETE_COLLECTION_ERROR';

export const ADD_TO_COLLECTION_START = 'ADD_TO_COLLECTION_START';
export const ADD_TO_COLLECTION_SUCCESS = 'ADD_TO_COLLECTION_SUCCESS';
export const ADD_TO_COLLECTION_ERROR = 'ADD_TO_COLLECTION_ERROR';

export const REMOVE_FROM_COLLECTION_START = 'REMOVE_FROM_COLLECTION_START';
export const REMOVE_FROM_COLLECTION_SUCCESS = 'REMOVE_FROM_COLLECTION_SUCCESS';
export const REMOVE_FROM_COLLECTION_ERROR = 'REMOVE_FROM_COLLECTION_ERROR';

export const COMMENT_COLLECTION_START = 'COMMENT_COLLECTION_START';
export const COMMENT_COLLECTION_SUCCESS = 'COMMENT_COLLECTION_SUCCESS';
export const COMMENT_COLLECTION_ERROR = 'COMMENT_COLLECTION_ERROR';

export const DUP_COLLECTION_START = 'DUP_COLLECTION_START';
export const DUP_COLLECTION_SUCCESS = 'DUP_COLLECTION_SUCCESS';
export const DUP_COLLECTION_ERROR = 'DUP_COLLECTION_ERROR';

export const RENAME_COLLECTION_START = 'RENAME_COLLECTION_START';
export const RENAME_COLLECTION_SUCCESS = 'RENAME_COLLECTION_SUCCESS';
export const RENAME_COLLECTION_ERROR = 'RENAME_COLLECTION_ERROR';

export const CHECK_BUILDING_START = 'CHECK_BUILDING_START';
export const CHECK_BUILDING_SUCCESS = 'CHECK_BUILDING_SUCCESS';
export const CHECK_BUILDING_ERROR = 'CHECK_BUILDING_ERROR';

// Favorites

export const LOAD_FAVORITES_START = 'LOAD_FAVORITES_START';
export const LOAD_FAVORITES_SUCCESS = 'LOAD_FAVORITES_SUCCESS';
export const LOAD_FAVORITES_ERROR = 'LOAD_FAVORITES_ERROR';

export const ADD_TO_FAVORITES_START = 'ADD_TO_FAVORITES_START';
export const ADD_TO_FAVORITES_SUCCESS = 'ADD_TO_FAVORITES_SUCCESS';
export const ADD_TO_FAVORITES_ERROR = 'ADD_TO_FAVORITES_ERROR';

export const REMOVE_FROM_FAVORITES_START = 'REMOVE_FROM_FAVORITES_START';
export const REMOVE_FROM_FAVORITES_SUCCESS = 'REMOVE_FROM_FAVORITES_SUCCESS';
export const REMOVE_FROM_FAVORITES_ERROR = 'REMOVE_FROM_FAVORITES_ERROR';

// Privacy

export const SWITCH_WITH_CLIENT = 'SWITCH_WITH_CLIENT';

// Payments

export const SHOW_PAYMENT_NOTIFCATION = 'SHOW_PAYMENT_NOTIFCATION';
export const HIDE_PAYMENT_NOTIFCATION = 'HIDE_PAYMENT_NOTIFCATION';

export const REQUEST_TO_CONNECT = 'REQUEST_TO_CONNECT';

export const GET_CITIES = 'GET_CITIES';
export const SET_CITIES = 'SET_CITIES';

export const GET_BANNER = 'GET_BANNER';
export const SET_BANNER = 'SET_BANNER';

// Appointments

export const LOAD_CALENDAR = 'LOAD_CALENDAR';
export const LOAD_CALENDAR_SUCCESS = 'LOAD_CALENDAR_SUCCESS';
export const LOAD_CALENDAR_ERROR = 'LOAD_CALENDAR_ERROR';

export const LOAD_APPOINTMENT_STATUSES = 'LOAD_APPOINTMENT_STATUSES';
export const LOAD_APPOINTMENT_STATUSES_SUCCESS = 'LOAD_APPOINTMENT_STATUSES_SUCCESS';
export const LOAD_APPOINTMENT_STATUSES_ERROR = 'LOAD_APPOINTMENT_STATUSES_ERROR';

export const LOAD_CREATE_APPOINTMENT = 'LOAD_CREATE_APPOINTMENT';
export const LOAD_CREATE_APPOINTMENT_SUCCESS = 'LOAD_CREATE_APPOINTMENT_SUCCESS';
export const LOAD_CREATE_APPOINTMENT_ERROR = 'LOAD_CREATE_APPOINTMENT_ERROR';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js